import cloneDeep from 'lodash/cloneDeep';
import type { GameTutorialState, GameTutorialStep } from './types';

export class GameTutorialModel {
  private readonly state: GameTutorialState;

  private activeStep?: GameTutorialStep;

  constructor(state: GameTutorialState) {
    this.state = cloneDeep(state);
  }

  public getSetupSteps(): GameTutorialStep[] {
    return this.state.setupSteps ?? [];
  }

  public setNextStep(): GameTutorialStep | undefined {
    if (this.activeStep) this.state?.steps.shift();
    this.activeStep = this.state?.steps.at(0);
    return this.activeStep;
  }

  public getActiveStep(): GameTutorialStep | undefined {
    return this.activeStep;
  }
}
